var map = {
	"./arrow-down.svg": [
		"e868",
		"chunk-2d22636b"
	],
	"./arrow-up.svg": [
		"178d",
		"chunk-2d0abcc8"
	],
	"./button-arrow.svg": [
		"e117",
		"chunk-2d224888"
	],
	"./check.svg": [
		"7c97",
		"chunk-2d0e1c20"
	],
	"./chevron-down-bold.svg": [
		"55da",
		"chunk-2d0c8c13"
	],
	"./chevron-down.svg": [
		"7b60",
		"chunk-2d0e17fb"
	],
	"./chevron-up-bold.svg": [
		"1190",
		"chunk-2d0aa62d"
	],
	"./chevron-up.svg": [
		"7e55",
		"chunk-2d0e2324"
	],
	"./details-bonds.svg": [
		"a941",
		"chunk-2d20956b"
	],
	"./details-chf.svg": [
		"7125",
		"chunk-2d0d5f93"
	],
	"./details-eur.svg": [
		"06ec",
		"chunk-2d0a4a1a"
	],
	"./details-europe.svg": [
		"3f32",
		"chunk-2d0c5528"
	],
	"./details-liquidity.svg": [
		"d30d",
		"chunk-2d21dbb9"
	],
	"./details-north-america.svg": [
		"5d50",
		"chunk-2d0d36a0"
	],
	"./details-other-asset.svg": [
		"61a1",
		"chunk-2d0cf0e1"
	],
	"./details-other-currency.svg": [
		"fefc",
		"chunk-2d2386b2"
	],
	"./details-other-region.svg": [
		"c325",
		"chunk-2d216769"
	],
	"./details-shares.svg": [
		"da59",
		"chunk-2d2288d7"
	],
	"./details-switzerland.svg": [
		"61e5",
		"chunk-2d0cf161"
	],
	"./details-usd.svg": [
		"bd12",
		"chunk-2d21aad9"
	],
	"./dividends-slider.svg": [
		"d9a1",
		"chunk-2d21f7fb"
	],
	"./dividends.svg": [
		"9372",
		"chunk-2d0e506b"
	],
	"./education.svg": [
		"ee64",
		"chunk-2d230c54"
	],
	"./energy-transition-slider.svg": [
		"9e1c",
		"chunk-2d0f0b94"
	],
	"./energyPolicyTurnaround.svg": [
		"d9eb",
		"chunk-2d21f8a8"
	],
	"./error.svg": [
		"ec89",
		"chunk-2d230515"
	],
	"./idDocument.svg": [
		"8e38",
		"chunk-2d0e9748"
	],
	"./immo.svg": [
		"e873",
		"chunk-2d226385"
	],
	"./leaf.svg": [
		"95f2",
		"chunk-2d0e5d9e"
	],
	"./mobile-finish-request-existing-customer.svg": [
		"1aab",
		"chunk-2d0b5f67"
	],
	"./mobile-finish-request-new-customer.svg": [
		"f414",
		"chunk-2d22c827"
	],
	"./moneyBundle.svg": [
		"db6c",
		"chunk-2d228ce1"
	],
	"./no-theme-slider.svg": [
		"b36c",
		"chunk-2d20f3b4"
	],
	"./noTheme.svg": [
		"a18d",
		"chunk-2d207812"
	],
	"./other-investments-no.svg": [
		"50f6",
		"chunk-2d0c7961"
	],
	"./other-investments-yes.svg": [
		"ad9f",
		"chunk-2d2137a6"
	],
	"./pillar.svg": [
		"fdad",
		"chunk-2d238257"
	],
	"./qr-code-box-step-1-existing-user.svg": [
		"676c",
		"chunk-2d0d0264"
	],
	"./qr-code-box-step-2-existing-user.svg": [
		"c8ec",
		"chunk-2d218089"
	],
	"./qr-code-box-steps-new-user.svg": [
		"6dd8",
		"chunk-2d0db0b8"
	],
	"./radio-square-checked.svg": [
		"94f4",
		"chunk-2d0e59df"
	],
	"./radio-square.svg": [
		"c5e5",
		"chunk-2d217518"
	],
	"./radio.svg": [
		"56cf",
		"chunk-2d0c8fba"
	],
	"./radio_checked.svg": [
		"a845",
		"chunk-2d2091ae"
	],
	"./radio_checked_dark.svg": [
		"c5a0",
		"chunk-2d217497"
	],
	"./regional-focus-ch.svg": [
		"9ca5",
		"chunk-2d0f09b4"
	],
	"./regional-focus-world.svg": [
		"990f",
		"chunk-2d0e664c"
	],
	"./success.svg": [
		"dda7",
		"chunk-2d22996c"
	],
	"./swiss-geomarker.svg": [
		"3677",
		"chunk-2d0ba179"
	],
	"./tech-progress-slider.svg": [
		"3858",
		"chunk-2d0ba8be"
	],
	"./techProgress.svg": [
		"f8b0",
		"chunk-2d22dd16"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ba33";
module.exports = webpackAsyncContext;